import React from 'react';
import { MobileApp } from 'ui';

const MobileAppPage = (): JSX.Element => {
  return <MobileApp />;
};

export default MobileAppPage;
